/* Bilingual content for X10 Management. All translatable UI strings live here. */

export const translations = {
  de: {
    nav: {
      services: "Leistungen",
      about: "Über uns",
      team: "Team",
      why: "Warum X10",
      careers: "Karriere",
      news: "News",
      contact: "Kontakt",
      cta: "Kontaktieren Sie uns!",
    },
    hero: {
      badge: "Transforming the Mittelstand",
      title_a: "Wir transferieren",
      title_a_accent: "integrierte Expertise",
      title_b: "in",
      title_b_accent: "neue Marktchancen und Wettbewerbsvorteile.",
      title_highlight: "",
      title_c: "",
      subtitle:
        "Herzlich willkommen bei der X10 Management GmbH, die ganzheitliche Unternehmensberatung\nfür den deutschen Mittelstand. Wir unterstützen Unternehmen, nachhaltige Wettbewerbsvorteile zu erzielen.\nMessbar! Keine theoretischen Konzepte.\n\nIn einer Zeit voller technologischer Veränderungen und wachsender internationaler Herausforderungen verbinden wir strategisches Denken mit operativer Umsetzung zu einem ganzheitlichen Beratungsansatz speziell für kleine und mittelständische Unternehmen.\n\nEin Schwerpunkt unserer Arbeit liegt in der Begleitung von KMU's in die Verteidigungs- und Sicherheitswirtschaft: Wir identifizieren relevante Geschäftschancen, analysieren Ausschreibungen und unterstützen unsere Kunden beim Aufbau der notwendigen Strukturen für eine erfolgreiche Marktpositionierung.",
      cta_contact: "Kontakt aufnehmen",
      cta_services: "Unsere Leistungen",
      stats: [
        { t: "Mittelstandsfokus", s: "Kompetenzfeld KMU" },
        { t: "Ganzheitliche Expertise", s: "Über Branchen hinweg" },
        { t: "Starke Netzwerke", s: "Lokal. National. International." },
        { t: "Knowledge Transfer", s: "Von der Idee zur Umsetzung" },
      ],
    },
    services: {
      eyebrow: "Unsere Leistungen",
      title: "Vier Kernfelder. Ein Ziel.",
      titleAccent: "Transforming the Mittelstand.",
      lead:
        "Ein roter Faden – Resilienz, Effizienz und Zukunftsfähigkeit. Drei zusammenhängende Transformationsfelder, die sich gegenseitig verstärken und den Mittelstand strategisch neu aufstellen.",
      thread: "Resilienz · Effizienz · Zukunftsfähigkeit",
      venn: {
        center: "OPTIMUM",
        resilience: { title: "Resilienz", text: "Widerstandsfähig\ngegenüber\nVeränderungen" },
        efficiency: { title: "Effizienz", text: "Prozesse optimieren\nRessourcen gezielt\neinsetzen" },
        future: { title: "Zukunftsfähigkeit", text: "Innovationen nutzen\nWachstum sichern" },
      },
      more: "Mehr erfahren →",
      items: {
        efficiency: {
          title: "Prozessoptimierung\n& Strukturen",
          short:
            "Wir analysieren Prozesse, Strukturen und Wertströme – und decken konkrete Potenziale zur Effizienzsteigerung auf.\n\nGemeinsam entwickeln wir schlanke Strukturen, die Produktivität, Transparenz und Wettbewerbsfähigkeit messbar erhöhen.",
        },
        realignment: {
          title: "Defense & Security\nMarktchancen",
          short:
            "Der europäische Verteidigungs- und Sicherheitsmarkt entwickelt sich zu einem der größten Wachstumsmärkte der nächsten Jahre.\n\nWir begleiten Unternehmen bei der strategischen Positionierung, Markterschließung und Integration in sicherheitsrelevante Wertschöpfungsketten.",
        },
        digital: {
          title: "Supply Chain\n& Nearshoring",
          short:
            "Resiliente Lieferketten sind heute ein zentraler Wettbewerbsfaktor – längst kein reines Beschaffungsthema mehr.\n\nWir entwickeln Nearshoring-Strategien und gestalten Beschaffungs- und Produktionsstrukturen flexibel, transparent und zukunftssicher.",
        },
        ai_robotics: {
          title: "Industrial AI\n& Robotics",
          short:
            "KI, Robotik und Automatisierung definieren die nächste Stufe industrieller Wertschöpfung – und sind heute bereits technisch realisierbar.\n\nWir begleiten von der Use-Case-Identifikation bis zur Skalierung intelligenter Technologien entlang Ihrer Wertschöpfungskette.",
        },
      },
    },
    about: {
      eyebrow: "Über X10 Management",
      title: "Erkennen. Bewerten. Umsetzen.\nWir begleiten Unternehmen von der Analyse bis zum Ergebnis.",
      body:
        "X10 unterstützt Unternehmen bei der digitalen Transformation, Prozessoptimierung, dem Einsatz Künstlicher Intelligenz sowie der Entwicklung resilienter Geschäfts- und Lieferketten.\n\nWir begleiten Unternehmen dabei, analoge Strukturen in digitale Wertschöpfungsprozesse zu überführen, Daten nutzbar zu machen und moderne Technologien gezielt einzusetzen. Von der Digitalisierung bestehender Abläufe über datengetriebenes Asset Management bis hin zu KI-gestützten Entscheidungs- und Automatisierungslösungen schaffen wir die Grundlage für mehr Transparenz, Effizienz und Wettbewerbsfähigkeit.\n\nDarüber hinaus unterstützen wir Unternehmen bei der Optimierung von Organisationen, Prozessen und Wertschöpfungsketten. Gemeinsam identifizieren wir Potenziale zur Effizienzsteigerung, reduzieren Komplexität und entwickeln skalierbare Strukturen für nachhaltiges Wachstum. Ergänzend begleiten wir unsere Kunden bei Nearshoring-Strategien, dem Aufbau resilienter Supply Chains, der Erschließung neuer Märkte sowie der Positionierung im Public Sector und der Verteidigungs- und Sicherheitswirtschaft. Das Ergebnis sind zukunftsfähige Unternehmen mit klaren Prozessen, belastbaren Lieferketten und messbaren Wettbewerbsvorteilen.",
      hq: "Hauptsitz",
      city: "Bochum, Deutschland",
      missionLabel: "Mission",
      mission:
        '"Wir machen komplexe Transformationen einfach – durch klares Denken, erprobte Methoden und konsequente Umsetzung."',
      values: [
        { title: "Effizienz", text: "Schlanke Prozesse als Fundament jeder erfolgreichen Organisation." },
        { title: "Innovation", text: "Mut zu neuen Wegen – mit pragmatischer Umsetzbarkeit." },
        { title: "Verlässlichkeit", text: "Partnerschaftlich, transparent und langfristig orientiert." },
        { title: "Messbare Ergebnisse", text: "Klare KPIs, dokumentierter Impact, nachvollziehbarer ROI." },
      ],
    },
    team: {
      eyebrow: "Unser Team",
      title: "Experten für den\nKnowledge-Transfer.",
      lead:
        "Wir kombinieren Management-Erfahrung, technologische Expertise und tiefes Branchenverständnis mit einem breiten Netzwerk.",
      members: [
        {
          role: "Partner & Managing Director",
          bio: "Cengiz Kosan verfügt über langjährige Erfahrung in den Bereichen Business Development und Unternehmensentwicklung mit dem Fokus auf der Entwicklung resilienter Supply Chains, sowie neuer Markt- und Wachstumspotenziale für Start-Up's und etablierte KMU's.",
        },
        {
          role: "Senior Consultant",
          bio: "Martina Gallo berät Unternehmen bei der Einführung innovativer Technologien in Industrie und Mittelstand. Ihr Fokus liegt auf Künstlicher Intelligenz, Robotik und der Digitalisierung von Prozessen entlang der gesamten Wertschöpfungskette.",
        },
        {
          role: "Lead Consultant",
          bio: "Yasemin Erdal unterstützt kleine und mittelständische Unternehmen bei der Erschließung öffentlicher Aufträge. Ihr Fokus liegt auf der Identifikation geeigneter Vergabeverfahren sowie der professionellen Begleitung im öffentlichen Beschaffungswesen.",
          joining: "Neu im Team ab September 2026",
        },
      ],
    },
    why: {
      eyebrow: "Warum X10",
      title: "Beratung, die im Tagesgeschäft wirkt – nicht nur auf Folien.",
      subTitle: "Vier Gründe, warum sich Unternehmen für X10 als Partner entscheiden",
      subLead:
        "Wir verbinden strategische Beratung mit ökonomischer Weitsicht und schaffen so echten Mehrwert aus einer Hand.",
      stats: [
        { t: "Mittelstandsfokus", s: "Kompetenzfeld KMU" },
        { t: "Ganzheitliche Expertise", s: "Über Branchen hinweg" },
        { t: "Starke Netzwerke", s: "Lokal. National. International." },
        { t: "Knowledge Transfer", s: "Von der Idee zur Umsetzung" },
      ],
      advantages: [
        { title: "Strategische Transformation für den Mittelstand", text: "Wir begleiten Unternehmen bis zur produktiven Umsetzung – mit klaren Zielen, sauberer Methodik und Ergebnisorientierung." },
        { title: "Know-how-Transfer für KI, Robotik und Zukunftstechnologien", text: "Wir zeigen, was morgen möglich ist – und wie Unternehmen heute davon profitieren können." },
        { title: "Defense & Security Market Access", text: "Wir unterstützen Unternehmen beim Zugang zu öffentlichen Ausschreibungen, Förderprogrammen und Beschaffungsprojekten der Verteidigungs- und Sicherheitswirtschaft." },
        { title: "International Business & Strategic Networks", text: "Wir verbinden Unternehmen nicht nur mit weltweit relevanten Akteuren: Durch unser Netzwerk aus Industrie, Verbänden, Forschungseinrichtungen und öffentlichen Auftraggebern schaffen wir Zugang zu neuen Märkten und Geschäftspotenzialen." },
      ],
    },
    insights: {
      eyebrow: "News & Insights",
      title: "Aktuelle Perspektiven aus\nunserer Beratungspraxis.",
      featured: "Featured",
      read: "Artikel lesen",
      all: "Alle",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Lassen Sie uns über Ihr Vorhaben sprechen.",
      lead:
        "Ob Erstgespräch, konkretes Projekt oder strategische Sparring-Session – wir freuen uns auf Ihre Nachricht und melden uns innerhalb eines Werktages.",
      address: "Adresse",
      email: "E-Mail",
      phone: "Telefon",
      labels: {
        name: "Name *",
        company: "Unternehmen",
        emailField: "E-Mail *",
        phoneField: "Telefon",
        discipline: "Welche Disziplin interessiert Sie?",
        message: "Ihre Nachricht *",
      },
      disciplineOptions: {
        none: "Bitte wählen (optional)",
        process: "Prozessoptimierung",
        supply_chain: "Defense & Security Markt",
        industrial_ai: "Supply Chain Resilience & Nearshoring",
        ai_robotics: "Industrial AI & Robotics",
        other: "Sonstiges / Allgemeine Anfrage",
      },
      gdpr:
        "Ich stimme zu, dass meine Angaben zur Kontaktaufnahme gespeichert werden. Die Einwilligung kann jederzeit widerrufen werden. Weitere Informationen in der ",
      gdprLink: "Datenschutzerklärung",
      submit: "Nachricht senden",
      sending: "Wird gesendet…",
      success: "Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
      error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      gdprError: "Bitte stimmen Sie der Datenschutzerklärung zu.",
      requiredError: "Bitte füllen Sie alle Pflichtfelder aus.",
    },
    footer: {
      tagline:
        "X10 Management GmbH – Beratung für Prozess-Exzellenz, KI und digitale Transformation. Mit Sitz in Bochum, tätig in ganz Europa.",
      nav: "Navigation",
      legal: "Rechtliches",
      legalLinks: { imprint: "Impressum", privacy: "Datenschutz", terms: "AGB", cookies: "Cookies" },
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      madeIn: "Made in Germany",
    },
    cookies: {
      title: "Wir respektieren Ihre Privatsphäre",
      body:
        "Wir verwenden ausschließlich technisch notwendige Cookies, damit diese Website zuverlässig funktioniert. Es findet kein Tracking statt. Details in unserer Datenschutzerklärung.",
      accept: "Verstanden",
      decline: "Nur notwendige",
      learn: "Mehr erfahren",
    },
    careers: {
      eyebrow: "Karriere · Join X10",
      title: "Karriere bei",
      titleAccent: "X10",
      lead: "Gestalte die Transformation des deutschen Mittelstands aktiv mit.",
      body:
        "Wir suchen Menschen mit Neugier, analytischem Denken und unternehmerischem Mindset. Arbeite an Projekten rund um Digitalisierung, KI, Prozessoptimierung, Nearshoring, Public Sector und Supply Chain Transformation.",
      cta: "Offene Positionen entdecken",
      role: {
        eyebrow: "Open Role",
        title: "Trainee Consultant (m/w/d)",
        subtitle: "Business Transformation & Operational Excellence",
      },
      highlights: [
        "Digitalisierung",
        "KI & Analytics",
        "Prozessoptimierung",
        "Nearshoring",
        "Public Sector",
        "Supply Chain",
      ],
    },
    legal: {
      back: "Zurück zur Startseite",
      imprint: {
        title: "Impressum",
        updated: "Stand: Dezember 2025",
      },
      privacy: {
        title: "Datenschutzerklärung",
        updated: "Stand: Dezember 2025",
      },
      terms: {
        title: "Allgemeine Geschäftsbedingungen",
        updated: "Stand: Dezember 2025",
      },
    },
    blog: { back: "Zurück zu News", anchor: "Alle Artikel", cta: "Beratung anfragen", loading: "Lade Artikel…", notFound: "Artikel nicht gefunden" },
  },

  en: {
    nav: {
      services: "Services",
      about: "About",
      team: "Team",
      why: "Why X10",
      careers: "Careers",
      news: "News",
      contact: "Contact",
      cta: "Contact us!",
    },
    hero: {
      badge: "Transforming the Mittelstand",
      title_a: "We transfer",
      title_a_accent: "integrated expertise",
      title_b: "into",
      title_b_accent: "new market opportunities and competitive advantages.",
      title_highlight: "",
      title_c: "",
      subtitle:
        "Welcome to X10 Management GmbH, the holistic management consultancy\nfor the German Mittelstand. We help companies achieve sustainable competitive advantages.\nMeasurable. No theoretical concepts.\n\nIn times of rapid technological change and growing international challenges, we combine strategic thinking with operational execution into a holistic consulting approach – tailored to small and medium-sized enterprises.\n\nA key focus of our work is supporting SMEs entering the defense and security industry: we identify relevant business opportunities, analyse tenders and help our clients build the structures needed for successful market positioning.",
      cta_contact: "Get in touch",
      cta_services: "Our services",
      stats: [
        { t: "Mittelstand Focus", s: "SME competence area" },
        { t: "Holistic Expertise", s: "Across industries" },
        { t: "Strong Networks", s: "Local. National. International." },
        { t: "Knowledge Transfer", s: "From idea to execution" },
      ],
    },
    services: {
      eyebrow: "What we do",
      title: "Four core fields. One goal.",
      titleAccent: "Transforming the Mittelstand.",
      lead:
        "One red thread – resilience, efficiency and future readiness. Three interconnected transformation fields that reinforce each other and reposition the Mittelstand strategically.",
      thread: "Resilience · Efficiency · Future readiness",
      venn: {
        center: "OPTIMUM",
        resilience: { title: "Resilience", text: "Resilient to\ndynamic change" },
        efficiency: { title: "Efficiency", text: "Optimise processes\nDeploy resources\npurposefully" },
        future: { title: "Future Readiness", text: "Leverage innovation\nSecure growth" },
      },
      more: "Learn more →",
      items: {
        efficiency: {
          title: "Process Optimization\n& Structures",
          short:
            "We analyse processes, structures and value streams – and uncover concrete potential for efficiency gains.\n\nTogether we build lean structures that measurably increase productivity, transparency and competitiveness.",
        },
        realignment: {
          title: "Defense & Security\nOpportunities",
          short:
            "The European defense and security market is evolving into one of the largest growth markets of the coming years.\n\nWe support companies in strategic positioning, market entry and integration into security-relevant value chains.",
        },
        digital: {
          title: "Supply Chain\n& Nearshoring",
          short:
            "Resilient supply chains have become a central competitive factor – no longer a mere procurement topic.\n\nWe develop nearshoring strategies and design procurement and production structures that are flexible, transparent and future-proof.",
        },
        ai_robotics: {
          title: "Industrial AI\n& Robotics",
          short:
            "AI, robotics and automation define the next stage of industrial value creation – and are already technically feasible today.\n\nWe support from use-case identification to scaling of intelligent technologies along your entire value chain.",
        },
      },
    },
    about: {
      eyebrow: "About X10 Management",
      title: "Identify. Evaluate. Execute.\nWe support companies from analysis to results.",
      body:
        "X10 supports companies in digital transformation, process optimisation, the use of Artificial Intelligence and the development of resilient business and supply chains.\n\nWe help organisations convert analogue structures into digital value chains, make data usable and deploy modern technologies with purpose. From digitalising existing workflows through data-driven asset management to AI-supported decision-making and automation solutions, we lay the foundation for greater transparency, efficiency and competitiveness.\n\nIn addition, we support companies in optimising organisations, processes and value chains. Together we identify efficiency potential, reduce complexity and build scalable structures for sustainable growth. We also accompany our clients in nearshoring strategies, building resilient supply chains, entering new markets and positioning themselves in the public sector and the defense and security industry. The result: future-ready companies with clear processes, robust supply chains and measurable competitive advantages.",
      hq: "Headquarters",
      city: "Bochum, Germany",
      missionLabel: "Mission",
      mission:
        '"We make complex transformations simple – through clear thinking, proven methods and consistent execution."',
      values: [
        { title: "Efficiency", text: "Lean processes as the foundation of every successful organisation." },
        { title: "Innovation", text: "Courage to find new paths – with pragmatic feasibility." },
        { title: "Reliability", text: "Partnership-driven, transparent and long-term oriented." },
        { title: "Measurable results", text: "Clear KPIs, documented impact, traceable ROI." },
      ],
    },
    team: {
      eyebrow: "Our team",
      title: "Experts in\nknowledge transfer.",
      lead:
        "We combine management experience, technological expertise and deep industry knowledge with a broad network.",
      members: [
        { role: "Partner & Managing Director", bio: "Cengiz Kosan has many years of experience in business development and corporate development, with a focus on building resilient supply chains and opening up new market and growth opportunities for start-ups and established SMEs." },
        { role: "Senior Consultant", bio: "Martina Gallo advises companies on the adoption of innovative technologies in industry and the Mittelstand. Her focus is on Artificial Intelligence, robotics and the digitalisation of processes along the entire value chain." },
        { role: "Lead Consultant", bio: "Yasemin Erdal supports small and medium-sized enterprises in accessing public contracts. Her focus is on identifying suitable tender procedures and providing professional guidance in public procurement.", joining: "Joining the team in September 2026" },
      ],
    },
    why: {
      eyebrow: "Why X10",
      title: "Consulting that works in the daily business – not just on slides.",
      subTitle: "Four reasons companies choose X10 as their partner.",
      subLead:
        "We combine strategic consulting with economic foresight – creating real, end-to-end value from a single partner.",
      stats: [
        { t: "Mittelstand Focus", s: "SME competence area" },
        { t: "Holistic Expertise", s: "Across industries" },
        { t: "Strong Networks", s: "Local. National. International." },
        { t: "Knowledge Transfer", s: "From idea to execution" },
      ],
      advantages: [
        { title: "Strategic transformation for the Mittelstand", text: "We guide companies all the way to productive implementation – with clear goals, sound methodology and an outcome-driven mindset." },
        { title: "Know-how transfer for AI, robotics and future technologies", text: "We show what tomorrow makes possible – and how companies can benefit from it today." },
        { title: "Defense & Security Market Access", text: "We support companies in accessing public tenders, funding programmes and procurement projects in the defense and security industry." },
        { title: "International Business & Strategic Networks", text: "We don't just connect companies with relevant stakeholders worldwide: Through our network of industry, associations, research institutions and public contracting authorities, we create access to new markets and business opportunities." },
      ],
    },
    insights: {
      eyebrow: "News & Insights",
      title: "Current perspectives from\nour consulting practice.",
      featured: "Featured",
      read: "Read article",
      all: "All",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk about your initiative.",
      lead:
        "Whether first conversation, concrete project or strategic sparring – we look forward to your message and respond within one business day.",
      address: "Address",
      email: "Email",
      phone: "Phone",
      labels: {
        name: "Name *",
        company: "Company",
        emailField: "Email *",
        phoneField: "Phone",
        discipline: "Which discipline are you interested in?",
        message: "Your message *",
      },
      disciplineOptions: {
        none: "Please select (optional)",
        process: "Process Optimization",
        supply_chain: "Defense & Security Market",
        industrial_ai: "Supply Chain Resilience & Nearshoring",
        ai_robotics: "Industrial AI & Robotics",
        other: "Other / General enquiry",
      },
      gdpr:
        "I agree that my data will be stored for the purpose of contact. The consent can be revoked at any time. More information in our ",
      gdprLink: "Privacy Policy",
      submit: "Send message",
      sending: "Sending…",
      success: "Thank you! We will get back to you within 24 hours.",
      error: "Something went wrong. Please try again.",
      gdprError: "Please accept the privacy policy.",
      requiredError: "Please fill in all required fields.",
    },
    footer: {
      tagline:
        "X10 Management GmbH – consultancy for process excellence, AI and digital transformation. Headquartered in Bochum, active across Europe.",
      nav: "Navigation",
      legal: "Legal",
      legalLinks: { imprint: "Imprint", privacy: "Privacy", terms: "Terms", cookies: "Cookies" },
      contact: "Contact",
      rights: "All rights reserved.",
      madeIn: "Made in Germany",
    },
    cookies: {
      title: "We respect your privacy",
      body:
        "We only use technically necessary cookies to make this website work reliably. No tracking. Details in our privacy policy.",
      accept: "Got it",
      decline: "Only necessary",
      learn: "Learn more",
    },
    careers: {
      eyebrow: "Careers · Join X10",
      title: "Careers at",
      titleAccent: "X10",
      lead: "Help us actively shape the transformation of the German Mittelstand.",
      body:
        "We are looking for people with curiosity, analytical thinking and an entrepreneurial mindset. Work on projects across digitalisation, AI, process optimisation, nearshoring, public sector and supply chain transformation.",
      cta: "Discover open positions",
      role: {
        eyebrow: "Open Role",
        title: "Trainee Consultant (m/f/d)",
        subtitle: "Business Transformation & Operational Excellence",
      },
      highlights: [
        "Digitalisation",
        "AI & Analytics",
        "Process Optimisation",
        "Nearshoring",
        "Public Sector",
        "Supply Chain",
      ],
    },
    legal: {
      back: "Back to homepage",
      imprint: { title: "Imprint", updated: "Last updated: December 2025" },
      privacy: { title: "Privacy Policy", updated: "Last updated: December 2025" },
      terms: { title: "Terms & Conditions", updated: "Last updated: December 2025" },
    },
    blog: { back: "Back to news", anchor: "All articles", cta: "Request consulting", loading: "Loading article…", notFound: "Article not found" },
  },
};

/* Service icons / numbers are language-agnostic */
export const SERVICE_KEYS = ["efficiency", "realignment", "digital", "ai_robotics"];
export const SERVICE_NUMBERS = { efficiency: "01", realignment: "02", digital: "03", ai_robotics: "04" };
